import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuthStore } from '../stores/authStore';
import { isEmailVerified } from '../utils/authUser';

interface AdminRouteProps {
  children: React.ReactNode;
}

/** Requires an ADMIN user; backend also enforces ADMIN via guards. */
const AdminRoute: React.FC<AdminRouteProps> = ({ children }) => {
  const user = useAuthStore((s) => s.user);
  const ready = useAuthStore((s) => s.initialized && !s.loading);
  const location = useLocation();
  const role = typeof user?.role === 'string' ? user.role.toUpperCase() : '';

  if (!ready) {
    return (
      <div className="min-h-[50vh] flex items-center justify-center bg-[#f3f2ef] text-gray-600">
        Loading…
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  if (!isEmailVerified(user)) {
    const email = typeof user.email === 'string' ? user.email : '';
    const qs = email ? `?email=${encodeURIComponent(email)}` : '';
    return <Navigate to={`/verify-email-pending${qs}`} replace />;
  }
  if (role !== 'ADMIN') {
    return <Navigate to="/" replace />;
  }

  return <>{children}</>;
};

export default AdminRoute;
